import { useCallback, useEffect, useRef } from 'react';

import { actions } from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/App';
import useApiError from 'hooks/useApiError';
import { useStatusContext } from 'pages/Status/context';

export default function useAlliumPending() {
  const { credit } = useStatusContext();

  const dispatch = useAppDispatch();
  const onError = useApiError('Error checking credit - please refresh');

  const checkCreditAndRevalidate = useCallback(
    (id: string) => {
      dispatch(
        actions.checkCredit({
          params: { id },
          onError,
          onSuccess: () => {
            actions.getCredit({
              params: { id },
              forceReload: true,
              onError,
            });
          },
        }),
      );
    },
    [dispatch, onError],
  );

  // Reference for autoredirect timer
  const timerRef = useRef<NodeJS.Timer | undefined>();
  // Function for autoredirect
  const startTimeout = useCallback(
    (id: string) => {
      clearTimeout(timerRef.current as NodeJS.Timeout);
      timerRef.current = setInterval(() => {
        checkCreditAndRevalidate(id);
      }, 5000);
    },
    [checkCreditAndRevalidate],
  );

  const creditIsCheckedRef = useRef<boolean>(false);
  useEffect(() => {
    if (!credit || creditIsCheckedRef.current) return;
    const id = credit?.id;
    if (!id) return;
    creditIsCheckedRef.current = true;
    startTimeout(id);
  }, [credit, checkCreditAndRevalidate, startTimeout]);
}
